import { render, staticRenderFns } from "./WesHelpPanel.vue?vue&type=template&id=0c9e3974&scoped=true"
import script from "./WesHelpPanel.vue?vue&type=script&lang=js"
export * from "./WesHelpPanel.vue?vue&type=script&lang=js"
import style0 from "./WesHelpPanel.vue?vue&type=style&index=0&id=0c9e3974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e3974",
  null
  
)

export default component.exports